import type { Telegram } from '@twa-dev/types';

/**
 * SDK Telegram — не npm-пакет, а скрипт telegram-web-app.js, подключённый
 * в index.html (https://github.com/TelegramMessenger/TGMiniAppsJsSDK).
 * Он кладёт объект в `window.Telegram`, типы берём из `@twa-dev/types`.
 */
declare global {
  interface Window {
    Telegram?: Telegram;
  }
}

export type { Telegram };
export type {
  SafeAreaInset,
  ThemeParams,
  WebApp,
  WebAppUser,
} from '@twa-dev/types';

/** Приложение открыто вне Telegram или скрипт SDK не загрузился. */
export class TelegramUnavailableError extends Error {
  constructor(message = 'Приложение доступно только внутри Telegram') {
    super(message);
    this.name = 'TelegramUnavailableError';
  }
}
